import type { GroupLetter } from '../types';

// Segmented control for the 3v3 schedule's group filter: an "ALL" chip plus one
// per round-robin group present. Mirrors EventTabs' `subtle` look (the public
// data-surface variant) so it sits naturally beside the schedule header. Used on
// both the desktop and mobile 3v3 schedule; 1v1 (Swiss, no groups) never renders it.
export function GroupFilter({ value, onChange, groups }: {
  value: GroupLetter | 'all';
  onChange: (g: GroupLetter | 'all') => void;
  groups: readonly GroupLetter[];
}) {
  const options: (GroupLetter | 'all')[] = ['all', ...groups];
  return (
    <div className="row r-md border overflow-hidden" role="group" aria-label="Filter by group">
      {options.map((g, i, arr) => {
        const on = value === g;
        return (
          <div
            key={g}
            onClick={() => onChange(g)}
            aria-pressed={on}
            className={`mono pad-btn-md txt-11 fw-bold tracking-2 cursor-pointer ${on ? 'bg-3 text-0' : 'text-2'}`}
            style={{ borderRight: i < arr.length - 1 ? 'var(--bw) solid var(--line)' : 'none' }}
          >
            {g === 'all' ? 'ALL' : g}
          </div>
        );
      })}
    </div>
  );
}
